export const imageSource = (imageId: number) => {
    return `${process.env.NEXT_PUBLIC_API_HOST}image/${imageId}`;
};